import React from 'react'
import ReactDOM from 'react-dom'
import 'react-app-polyfill/ie9' // IE 9-11
import 'react-app-polyfill/ie11' // IE 11
import 'react-app-polyfill/stable'
import { Provider } from 'react-redux'

import App from './App'

import * as serviceWorker from './serviceWorker'

import { ToastContainer } from 'react-toastify'

import './assets/sass/style2.scss'

import store from './store'

/**
 * push callback
 * 포그라운드 상태에서 푸시가 도착하는 경우, 푸시에 대한 payload값을 콜백으로 전달받는다.
 */
window.onReceiveAndroidNotification = function (...args) {
  console.log(args)
}

// TODO: iOS Callback Function 이름 확인하여 처리..

ReactDOM.render(
  <Provider store={store}>
    <App />
    <ToastContainer closeButton={false} />
  </Provider>,
  document.getElementById('app'),
)
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
